export default __webpack_public_path__ + "static/media/css-icon.d2811e59.png";